<template>
  <div
    style="width: 100%;
    height: 100%; padding:1cm;
    page-break-inside:avoid;
    page-break-before:always;
    "
    v-if="obj"
  >
    <tiss-box
      title="GUIA DE CONSULTA"
      :guiaPrestador="numeroGuia"
      largura="100%"
      :logo="logoURL"
      :operadora="logoText"
    >
      <div class="row mb-1">
        <div class="col d-flex flex-row">
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="1- Registro ANS"
            :value="registroANS"
            largura="130mm"
          ></tiss-field>
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="3- Número da Guia Atribuido pela Operadora"
            :value="numeroGuiaOperadora"
            largura="170mm"
          ></tiss-field>
        </div>
      </div>

      <!-- Dados do Beneficiário -->

      <div class="row">
        <div class="col">
          <tiss-sub-title title="Dados do Beneficiário"></tiss-sub-title>
        </div>
      </div>

      <div class="row mb-1">
        <div class="col d-flex flex-row">
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="4- Número da Carteira"
            :value="numCarteira"
            largura="100mm"
          ></tiss-field>
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="5- Validadde da Carteira"
            :value="validadeCarteira"
            largura="121mm"
          ></tiss-field>
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="6- Atendimento a RN (Sim ou Não)"
            :value="SouN(atendimentoRN)"
            largura="79mm"
          ></tiss-field>
        </div>
      </div>

      <div class="row mb-1">
        <div class="col d-flex flex-row" style="width:30cm;">
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="26 - Nome Social"
            :value="nomeSocialBeneficiario"
            largura="219.5mm"
          ></tiss-field>
        </div>
      </div>
      
      <div class="row mb-1">
        <div class="col d-flex flex-row" style="width:30cm;">
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="7- Nome"
            :value="nomeBeneficiario"
            largura="219.5mm"
          ></tiss-field>
          <!-- <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="8- Cartão Nacional de Saúde"
            value
            largura="77.4mm"
          ></tiss-field> -->
        </div>
      </div>

      <!-- Dados do Contratado -->

      <div class="row">
        <div class="col">
          <tiss-sub-title title="Dados do Contratado"></tiss-sub-title>
        </div>
      </div>

      <div class="row mb-1">
        <div class="col d-flex flex-row">
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="9- Código na Operadora"
            :value="codigoPrestadorNaOperadora"
            largura="100mm"
          ></tiss-field>
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="10- Nome do Contratado"
            :value="nomeContratado"
            largura="140mm"
          ></tiss-field>
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="11- Código CNES"
            :value="CNES"
            largura="60mm"
          ></tiss-field>
        </div>
      </div>

      <div class="row mb-1">
        <div class="col d-flex flex-row">
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="12- Nome do Profissional Executante"
            :value="nomeProfissional"
            largura="100mm"
          ></tiss-field>
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="13- Conselho"
            :value="conselhoProfissional"
            largura="40mm"
          ></tiss-field>
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="14- Número no Conselho"
            :value="numeroConselhoProfissional"
            largura="67mm"
          ></tiss-field>
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="15- UF"
            :value="UF"
            largura="30.6mm"
          ></tiss-field>
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="16- Código CBO"
            :value="cbos"
            largura="60.3mm"
          ></tiss-field>
        </div>
      </div>

      <!-- Dados do Procedimento -->

      <div class="row">
        <div class="col">
          <tiss-sub-title
            title="Dados do Atendimento / Procedimento Solicitado"
          ></tiss-sub-title>
        </div>
      </div>

      <div class="row mb-1">
        <div class="col d-flex flex-row">
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="17- Indicação de Acidente ou Doença Relacionada"
            :value="indicacaoAcidente"
            largura="100%"
          ></tiss-field>
        </div>
      </div>

      <div class="row mb-1">
        <div class="col d-flex flex-row">
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="18- Data do Atendimento"
            :value="dataAtendimento"
            largura="70mm"
          ></tiss-field>
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="19- Tipo de Consulta"
            :value="tipoConsulta"
            largura="60mm"
          ></tiss-field>
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="20- Tabela"
            :value="codigoTabela"
            largura="40mm"
          ></tiss-field>
          <tiss-field
            altura="1.0cm"
            fontSize="13pt"
            title="21- Código do Procedimento"
            :value="codigoProcedimento"
            largura="80mm"
          ></tiss-field>
          <tiss-field
            altura="1.0cm"
            fontSize="12pt"
            title="22- Valor do Procedimento"
            :value="valorProcedimento"
            largura="70mm"
          ></tiss-field>
        </div>
      </div>

      <div class="row mb-1">
        <div class="col d-flex flex-row">
          <tiss-field
            title="23- Observações / justificativa"
            :value="observacao"
            largura="100%"
            altura="3cm"
            :obrigatorio="false"
          ></tiss-field>
        </div>
      </div>

      <div class="row mb-1">
        <div class="col d-flex flex-row">
          <tiss-field
            altura="2.2cm"
            fontSize="12pt"
            title="24- Assinatura do Profissional Executante"
            value
            largura="150mm"
          ></tiss-field>
          <tiss-field
            altura="2.2cm"
            fontSize="12pt"
            title="25- Assinatura do Beneficiário ou Responsável"
            value
            largura="150mm"
          ></tiss-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <tiss-rodape
            :infoId="this.guia.id_atendimento"
            :idExterno="this.guia.st_id_externo"
            :id_guia="guia.id_guia"
            :id_atendimento="guia.id_atendimento"
            :responsavel="atendimento_usuario()"
            :large="true"
            :pageIndex="pageIndex"
            :pageCount="pageCount"
          ></tiss-rodape>
        </div>
      </div>
    </tiss-box>
  </div>

  <!-- Guia Consulta Versão 2.02.01 -->
  <!-- <GuiaDeConsultaTissV20201 v-else :guia="guia" :indice="indice" :guias="guias" :logo="logo" /> -->
</template>

<script>
import TissBox from "./TissBox.vue";
import TissField from "./TissField.vue";
import TissSubTitle from "./TissSubTitle.vue";
import TissRodape from "./TissRodape";
// import GuiaDeConsultaTissV20201 from "./GuiaDeConsultaTissV20201.vue";

export default {
  data() {
    return {
      largura: "21cm",
      rodape: ""
    };
  },

  props: ["guia", "logo", "operadora", "pageIndex", "pageCount"],

  components: {
    TissBox,
    TissField,
    TissSubTitle,
    TissRodape
    // GuiaDeConsultaTissV20201
  },

  methods: {
    SouN(st) {
      return st == "S" ? "SIM" : "NAO";
    },
    atendimento_usuario() {
      if (this.guia && this.guia.st_login) {
        return this.guia.st_login;
      }

      return null;
    },
    ocultar_valores() {
        return this.guia && this.guia.ocultar_valores;
    }
  },
  computed: {
    obj: function() {
      if (this.guia && this.guia.mensagemTISS != null) {
        return this.guia.mensagemTISS;
      }
      return null;
    },
    logoURL: function() {
      if (this.guia && this.guia.logo_url_front) {
        return this.guia.logo_url_front;
      }

      if (this.guia && this.guia.logo_text_front) {
        return null;
      }

      return this.logo
    },
    logoText: function() {
      if (this.guia && this.guia.logo_text_front) {
        return this.guia.logo_text_front;
      }

      return this.operadora ? this.operadora.search : '';
    },
    versao: function() {
      if (this.guia != null && this.guia.mensagemTISS != null) {
        return this.guia.mensagemTISS.cabecalho.Padrao
          ? this.guia.mensagemTISS.cabecalho.Padrao
          : this.guia.mensagemTISS.cabecalho.versaoPadrao
          ? this.guia.mensagemTISS.cabecalho.versaoPadrao
          : "";
      }
      return null;
    },
    numeroGuia: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
        .cabecalhoConsulta &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .cabecalhoConsulta.numeroGuiaPrestador
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .cabecalhoConsulta.numeroGuiaPrestador
        : "";
    },
    numeroGuiaOperadora: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
         &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .numeroGuiaOperadora
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .numeroGuiaOperadora
        : "";
    },
    registroANS: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
        .cabecalhoConsulta &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .cabecalhoConsulta.registroANS
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .cabecalhoConsulta.registroANS
        : "";
    },
    numCarteira: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
        .dadosBeneficiario &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .dadosBeneficiario.numeroCarteira
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .dadosBeneficiario.numeroCarteira
        : "";
    },
    validadeCarteira: function() {
      if (this.guia.dt_validade_carteira) {
        return this.$util.getFormatDate(
          this.guia.dt_validade_carteira,
          "DD/MM/YYYY"
        );
      }
      return "";
    },
    atendimentoRN: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
        .dadosBeneficiario &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .dadosBeneficiario.atendimentoRN
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .dadosBeneficiario.atendimentoRN
        : "";
    },
    nomeBeneficiario: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
        .dadosBeneficiario &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .dadosBeneficiario.nomeBeneficiario
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .dadosBeneficiario.nomeBeneficiario
        : "";
    },
    nomeSocialBeneficiario: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
        .dadosBeneficiario &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .dadosBeneficiario.nomeSocialBeneficiario &&
         !Array.isArray(this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .dadosBeneficiario.nomeSocialBeneficiario)
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .dadosBeneficiario.nomeSocialBeneficiario
        : "";
    },
    nomeContratado: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
        .contratadoExecutante &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .contratadoExecutante.nomeContratado
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .contratadoExecutante.nomeContratado
        : "";
    },
    CNES: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
        .contratadoExecutante &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .contratadoExecutante.CNES &&
          !Array.isArray(this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .contratadoExecutante.CNES)
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .contratadoExecutante.CNES
        : "";
    },
    codigoPrestadorNaOperadora: function() {
      let codPrestador = "";

      if (
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .contratadoExecutante
      ) {
        let contratado = this.obj.prestadorParaOperadora.loteGuias.guiasTISS
          .guiaConsulta.contratadoExecutante;

        if (contratado.codigoPrestadorNaOperadora) {
          codPrestador = contratado.codigoPrestadorNaOperadora;
        } else if (contratado.cpfContratado) {
          codPrestador = contratado.cpfContratado;
        } else if (contratado.cnpjContratado) {
          codPrestador = contratado.cnpjContratado;
        } else if (contratado.cpfContratado) {
          codPrestador = contratado.cpfContratado;
        }
      }
      return codPrestador;

      // codPrestador = this.obj.prestadorParaOperadora.loteGuias.guiasTISS
      //   .guiaConsulta.contratadoExecutante[Object.keys(this.obj.prestadorParaOperadora.loteGuias.guiasTISS
      //   .guiaConsulta.contratadoExecutante)[2]];
    },
    nomeProfissional: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
        .profissionalExecutante &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .profissionalExecutante.nomeProfissional
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .profissionalExecutante.nomeProfissional
        : "";
    },

    conselhoProfissional: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
        .profissionalExecutante &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .profissionalExecutante.conselhoProfissional
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .profissionalExecutante.conselhoProfissional
        : "";
    },
    numeroConselhoProfissional: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
        .profissionalExecutante &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .profissionalExecutante.numeroConselhoProfissional
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .profissionalExecutante.numeroConselhoProfissional
        : "";
    },
    UF: function() {
      if (
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .profissionalExecutante &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .profissionalExecutante.UF
      ) {
        return this.$util.siglaUF(
          this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .profissionalExecutante.UF
        );
      }
      return "";
    },
    cbos: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
        .profissionalExecutante &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .profissionalExecutante.CBOS
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .profissionalExecutante.CBOS
        : "";
    },
    indicacaoAcidente: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .indicacaoAcidente
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .indicacaoAcidente
        : "";
    },
    dataAtendimento: function() {
      let data = "";
      if (
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .dadosAtendimento &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .dadosAtendimento.dataAtendimento
      )
        data = this.$util.getFormatDate(
          this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .dadosAtendimento.dataAtendimento,
          "DD/MM/YYYY"
        );
      return data;
    },
    tipoConsulta: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
        .dadosAtendimento &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .dadosAtendimento.tipoConsulta
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .dadosAtendimento.tipoConsulta
        : "";
    },
    codigoTabela: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
        .dadosAtendimento &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .dadosAtendimento.procedimento &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .dadosAtendimento.procedimento.codigoTabela
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .dadosAtendimento.procedimento.codigoTabela
        : "";
    },
    codigoProcedimento: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
        .dadosAtendimento &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .dadosAtendimento.procedimento &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .dadosAtendimento.procedimento.codigoProcedimento
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .dadosAtendimento.procedimento.codigoProcedimento
        : "";
    },
    valorProcedimento: function() {
      return !this.ocultar_valores() && this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
        .dadosAtendimento &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .dadosAtendimento.procedimento &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .dadosAtendimento.procedimento.valorProcedimento
        ? this.$util.formatMoeda(
            this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
              .dadosAtendimento.procedimento.valorProcedimento
          )
        : "";
    },
    observacao: function() {
      return this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta &&
        this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
          .observacao
        ? this.obj.prestadorParaOperadora.loteGuias.guiasTISS.guiaConsulta
            .observacao
        : "";
    },
  }
};
</script>

<style scoped>
@page {
  size: 21cm 29.7cm;
  xmargin: 30mm 45mm 30mm 45mm;
  /* change the margins as you want them to be. */
}

@media print {
  body {
    width: 21cm;
    height: 29.7cm;
    xmargin: 30mm 45mm 30mm 45mm;
    /* change the margins as you want them to be. */
  }
}
</style>
